import React from "react";
import SideBar from "./SideBar";
import DrugImage from "../../Images/3_Drug.jpg";

const ComputationalDrugDesign = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar drug={true} />
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5">Computational Drug Design</div>
          <hr />
          <div className="row">
            <div className="col-md-7">
              <p className="mb-auto textAlign">
                Neurodegenerative diseases or dementia is a growing healthcare
                crisis worldwide because no treatment is currently available
                except a few symptomatic medications. We apply Computer Aided
                Drug Design (CADD) models, Quantum mechanics, Molecular dynamics
                (MD), and Machine learning (ML) methods to develop a novel drug
                and understand the physicochemical behavior of Alzheimer&#39;s
                disease. Our aim is to provide molecular-level knowledge for
                structure modification to improve the design of Alzheimer&#39;s
                drugs.
              </p>
            </div>
            <div className="col-md-5 text-center">
              <div className="card-text mb-auto research p-3">
                <img src={DrugImage} alt="" />
              </div>
            </div>
          </div>
          <div className="heading mt-4">Recent Publications</div>
          <hr />
          <div className="mb-4 textAlign">
            No recent publications
            {/* <li>
              Das CK and Singh JK, &nbsp;
              <a href="#" className="remove-underline" target={"_blank"}>
                <font color="808000">
                  "Effect of confinement on the solid-liquid coexistence of
                  Lennard-Jones Fluid".
                </font>
              </a>
              <font color="008080"> J. Chem. Phys. 139, 174706(2013) </font>
            </li> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComputationalDrugDesign;
